import { Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AspectosMejorar from "../../components/Form/Fields/AspectosMejorar";
import ContextoEspecíficoEstudiante from "../../components/Form/Fields/ContextoEspecíficoEstudiante";
import Fortalezas from "../../components/Form/Fields/Fortalezas";
import Longitud from "../../components/Form/Fields/Longitud";
import Periodo from "../../components/Form/Fields/Periodo";
import TituloInforme from "../../components/Form/Fields/TituloInforme";
import TonoMensaje from "../../components/Form/Fields/TonoMensaje";
import InformeDesempenoCardImg from "../../components/UmmIApps/Cards/InformeDesempenoCardImg.png";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const InformeDesempenoPage = () => {
  const {
    nivelId,
    materiaId,
    promptData,
    handleBack,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("informe_desempeno", { promptData });
  const colorIconBack = "#6A93A8";

  useEffect(() => {
    const init = {
      titulo: "",
      periodo: "",
      fortalezas: [],
      mejoras: [],
      condiciones_contexto: [],
      tono: "",
      longitud: 120,
    };
    handleInitialPromptData(init, "informe_desempeno");
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={InformeDesempenoCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #C3D4DC 100%, #88A9B9 100%)"
        }
        titleColor="#6A93A8"
        title="Informe de desempeño"
        description="Genera informes de desempeño con fortalezas a destacar y aspectos a mejorar para cada uno de tus estudiantes."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
          display={"flex"}
          flexDirection={"row"}
          sx={{ mt: 4 }}
        >
          <TituloInforme />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Periodo />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Fortalezas />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <AspectosMejorar />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <ContextoEspecíficoEstudiante />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TonoMensaje />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Longitud />
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default InformeDesempenoPage;
